<template>
  <div class="homepage-casino-module">
    <slot v-if="isMobile">
        <div class="col direction-column left">
          <router-link v-for="(item,key) in casinoImages" :key="key" :to="'/' + item.url"><img height="205" :src="item.image"></router-link>
        </div>
        <div class="col direction-column right">
          <router-link v-for="(item,key) in slotImages" :key="key" :to="'/' + item.url"><img :src="item.image"></router-link>
        </div>
    </slot>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        casinoImages: [],
        slotImages:[],
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
        fetchData: function() {
            this.$store.dispatch('getBanner', ['casino', 'mobile', 'bottom'])
            .then(response =>{
              if(this.isMobile){
                this.casinoImages 	= !_.isUndefined(response.data) && !_.isEmpty(response.data) ? _.sortBy(response.data, ['sort']) : null;
              }
            });
            this.$store.dispatch('getBanner', ['slot', 'mobile', 'bottom'])
            .then(response =>{
              if(this.isMobile){
                this.slotImages 	= !_.isUndefined(response.data) && !_.isEmpty(response.data) ? _.sortBy(response.data, ['sort']) : null;
              }
            });

        },
    }
  }
</script>